document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.countdown').forEach((container) => {
    // 优先使用 data-end-timestamp（秒），否则用 data-end-time（ISO 字符串）
    let endTime = container.dataset.endTimestamp
      ? parseInt(container.dataset.endTimestamp, 10) * 1000
      : new Date(container.dataset.endTime).getTime();
    if (!endTime) return;

    const daysEl = container.querySelector('[data-days]');
    const hoursEl = container.querySelector('[data-hours]');
    const minutesEl = container.querySelector('[data-minutes]');
    const secondsEl = container.querySelector('[data-seconds]');
    const endedText = container.querySelector('.countdown__ended');
    const timeWrapper = container.querySelector('.countdown__time');

    const timer = setInterval(() => {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        clearInterval(timer);
        timeWrapper.style.display = 'none';
        endedText && endedText.classList.remove('hidden');
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }, 1000);
  });
});
